import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import SecondaryNav from '../../../components/SecondaryNav';
import SectionTitle from '../../../components/SectionTitle';
import { hasGrants, isCreditCardExpired } from '../../../js/me/selectors';
import notifications from '../../../js/notifications/reducers';

const messages = defineMessages({
  title: {
    id: 'Payments.title',
    defaultMessage: 'Credit',
  },
  remainingCredit: {
    id: 'Payments.remainingCredit.navLabel',
    defaultMessage: 'Remaining Credit',
  },
  transactions: {
    id: 'Payments.transactions.navLabel',
    defaultMessage: 'Transactions',
  },
  rechargeCredit: {
    id: 'Payments.rechargeCredit.navLabel',
    defaultMessage: 'Recharge Credit',
  },
  automaticRecharge: {
    id: 'Payments.automaticRecharge.navLabel',
    defaultMessage: 'Automatic Recharge',
  },
});

const nav = [
  {
    id: 'Payments.remainingCredit.linkLabel',
    href: '/administration/credit/remaining',
    label: messages.remainingCredit,
  },
  {
    id: 'Payments.transactions.linkLabel',
    href: '/administration/credit/transactions',
    label: messages.transactions,
  },
];

const Payments = ({ canRecharge, creditCardExpired, intl: { formatMessage }, children }) => {
  const rechargeTab = [{
    id: 'Payments.rechargeCredit.linkLabel',
    href: '/administration/credit/recharge',
    label: messages.rechargeCredit,
  }, {
    id: 'Payments.automaticRecharge.linkLabel',
    href: '/administration/credit/automatic-recharge',
    label: messages.automaticRecharge,
    notifications: creditCardExpired ? 1 : 0
  }];

  const tabs = canRecharge ? [...nav, ...rechargeTab] : nav;
  return (
    <div className="border rounded h-100 bg-white">
      <SectionTitle>{formatMessage(messages.title)}</SectionTitle>
      <SecondaryNav tabs={tabs} />
      <div className="yn-section-with-nav-scrolling">{children}</div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    canRecharge: hasGrants(state, 'PAYMENTS_PURCHASE'),
    creditCardExpired: isCreditCardExpired(state)
  };
}
export default injectIntl(connect(mapStateToProps)(Payments));
